import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import reimList from '@/components/reimList'
import reimDetail from '@/components/reimDetail'
import reimEdit from '@/components/reimEdit'
import reimSee from '@/components/reimSee'
import createCost from '@/components/createCost'
import costList from '@/components/costList'
import costDetail from '@/components/costDetail'
import seeCost from '@/components/seeCost'
import reimAppr from '@/components/reimAppr'
import reimApprEdit from '@/components/reimApprEdit'
import demo from '@/components/demo'
import demo2 from '@/components/demo2'
// 登录页
import login from '@/view/login'
// 修改密码
import modifyPwd from '@/view/index/mine/modify_pwd'
// 工作台
import workbench from '@/view/index/workbench'
// 任务
import taskDetail from '@/view/index/task/index'
// 菜单
import editMenu from '@/view/index/menu/editMenu'

// 合同信息总览
import contractOverview from '@/view/contract/contractOverview'
// 合同信息列表
import contractList from '@/view/contract/contractList'
// 合同详情页
import ctripDetail from '@/view/contract/detail/ctripDetail'
import humanDayoutDetail from '@/view/contract/detail/humanDayoutDetail'
import humanDayServiceDetail from '@/view/contract/detail/humanDayServiceDetail'
import humanDayTotalDetail from '@/view/contract/detail/humanDayTotalDetail'
import purchaseDetail from '@/view/contract/detail/purchaseDetail'
import technicalSoftwareDetail from '@/view/contract/detail/technicalSoftwareDetail'
import approveCont from '@/view/contract/approveCont'
import payRecordList from '@/view/payRecord/payRecordList'
import payPurchaseDetail from '@/view/payRecord/detail/payPurchaseDetail'
import payCtripDetail from '@/view/payRecord/detail/payCtripDetail'
import payHumanDayDetail from '@/view/payRecord/detail/payHumanDayDetail'
import ctripPersonInfo from '@/view/payRecord/detail/ctripPersonInfo'
import approvePay from '@/view/payRecord/approvePay'

import weekReportDetail from '@/view/weekReport/weekReportDetail'

//* ****** 合同开票 ***********
import invoList from '@/view/cmInvo/invo/invoList'
import invoDetail from '@/view/cmInvo/invo/invoDetail'
import invoHdServiceDetail from '@/view/cmInvo/invo/invoHdServiceDetail'
import invoHdTotalDetail from '@/view/cmInvo/invo/invoHdTotalDetail'
import invoDetailView from '@/view/cmInvo/invo/invoDetailView'
// 开票审批
import invoApproval from '@/view/cmInvo/invo/invoApproval'

//* ****** 立项 ***********
import projOverview from '@/view/pm/project/projectOverview'
import projectManager from '@/view/pm/project/projectManager'
import projList from '@/view/pm/project/projectList'
import projDetail from '@/view/pm/project/projectDetail'
import projApproval from '@/view/pm/project/projApproval'

//* *************打卡签到****************

import signIndex from '@/view/sign/signIndex'
import signRecord from '@/view/sign/signRecord'
import dayReportList from '@/view/sign/dayReportList'
import dayReportAdd from '@/view/sign/dayReportAdd'
import dayReportModify from '@/view/sign/dayReportModify'

import dayReportAuditList from '@/view/sign/dayReportAuditList'
import dayReportAuditDetail from '@/view/sign/dayReportAuditDetail'

//* ****** 项目预算 ***********
import budgetOverview from '@/view/pm/budget/budgetOverview'
import budgetManager from '@/view/pm/budget/budgetManager'
import budgetList from '@/view/pm/budget/budgetList'
import budgetDetail from '@/view/pm/budget/budgetDetail'
import budgetApproval from '@/view/pm/budget/budgetApproval'

//* ****** flyback ***********
import flybackApply from '@/view/flyback/flybackApply'
import flybackApplyDetail from '@/view/flyback/flybackApplyDetail'
import flybackApproval from '@/view/flyback/flybackApproval'
import flybackApplyList from '@/view/flyback/flybackApplyList'
import flybackApplyView from '@/view/flyback/flybackApplyView'

//* ****** flow 流程管理 ***********
import flowApplyList from '@/view/flow/flowApplyList'
import flowApplyDetail from '@/view/flow/flowApplyDetail'
import flowApplyEdit from '@/view/flow/flowApplyEdit'
import flowApplyAudit from '@/view/flow/flowApplyAudit'

//* ************ 企业微信相关模块********************
import taskLoading from '@/view/wechat/taskLoading'
import taskCenterLoading from '@/view/wechat/taskCenterLoading'
import taskCenter from '@/view/wechat/taskCenter'
// 日报跳转处理
import dailyDeal from '@/view/wechat/dailyDeal'

//* **************测试页面************* */
import preview from '@/view/test/preview'

Vue.use(Router)

export default new Router({


	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return {
				x: 0,
				y: 0
			}
		}
	},
	routes: [{
		path: '/login',
		name: 'login',
		component: login
	},
	{
		path: '/',
		name: 'workbench',
		component: workbench
	},
	{
		path: '/adminSys/procManager/taskDetail',
		name: 'taskDetail',
		component: taskDetail
	},
	{
		path: '/app/workRep/signIn',
		name: 'signIndex',
		component: signIndex
	},
	{
		path: '/app/workRep/signRecord',
		name: 'signRecord',
		component: signRecord
	},
	{
		path: '/app/workRep/dayReport',
		name: 'dayReportList',
		component: dayReportList,
		meta: {
			keepAlive: false // 需要缓存
		}
	},
	{
		path: '/app/workRep/dayReportAdd',
		name: 'dayReportAdd',
		component: dayReportAdd
	},
	{
		path: '/app/workRep/dayReportModify',
		name: 'dayReportModify',
		component: dayReportModify
	},
	{
		path: '/app/audit/dayReportAudit',
		name: 'dayReportAudit',
		component: dayReportAuditList,
		meta: {
			keepAlive: true // 需要缓存
		}
	},
	{
		path: '/app/audit/dayReportAuditDetail',
		name: 'dayReportAuditDetail',
		component: dayReportAuditDetail
	},
	{
		path: '/app/remb/reimList',
		name: 'reimList',
		component: reimList,
		meta: {
			keepAlive: true // 需要缓存
		}
	},
	{
		path: '/reimDetail',
		name: 'reimDetail',
		component: reimDetail
	},
	{
		path: '/reimEdit',
		name: 'reimEdit',
		component: reimEdit
	},
	{
		path: '/seeCost',
		name: 'seeCost',
		component: seeCost
	},
	{
		path: '/reimSee',
		name: 'reimSee',
		component: reimSee
	},
	{
		path: '/reimAppr',
		name: 'reimAppr',
		component: reimAppr
	},
	{
		path: '/reimApprEdit',
		name: 'reimApprEdit',
		component: reimApprEdit
	},
	{
		path: '/createCost',
		name: 'createCost',
		component: createCost
	},
	{
		path: '/app/project/cmInvo/invoList',
		name: '合同开票',
		component: invoList,
		meta: {
			keepAlive: true // 需要缓存
		}
	},
	{
		path: '/app/project/cmInvo/invoDetail',
		name: '合同开票详情',
		component: invoDetail
	},
	{
		path: '/app/project/cmInvo/invoHdServiceDetail',
		name: '人天服务合同开票申请',
		component: invoHdServiceDetail
	},
	{
		path: '/app/project/cmInvo/invoHdTotalDetail',
		name: '人天服务总价合同开票申请',
		component: invoHdTotalDetail
	},
	{
		path: '/app/project/cmInvo/invoDetailView',
		name: '合同开票详情查看',
		component: invoDetailView
	},
	{
		path: '/app/project/cmInvo/invoApproval',
		name: '合同开票审批',
		component: invoApproval
	},
	{
		path: '/app/project/pm/projectOverview',
		name: '立项总览',
		component: projOverview,
		//			meta: {
		//				keepAlive: true // 需要缓存
		//			}
	},
	{
		path: '/app/project/pm/projectManager',
		name: '售前人员',
		component: projectManager,
	},
	{
		path: '/app/project/pm/projectList',
		name: '立项列表',
		component: projList,
		// meta: {
		// 	keepAlive: true // 需要缓存
		// }
	},
	{
		path: '/app/project/pm/projDetail',
		name: '立项详情',
		component: projDetail,
		hidden: true
	},
	{
		path: '/project/projEst/estApproval',
		name: '立项审批',
		component: projApproval
	},
	{
		path: '/app/project/pm/budgetOverview',
		name: '项目预算总览',
		component: budgetOverview,
		//			meta: {
		//				keepAlive: true // 需要缓存
		//			}
	},
	{
		path: '/app/project/pm/budgetManager',
		name: '预算售前人员',
		component: budgetManager,
	},
	{
		path: '/app/project/pm/budgetList',
		name: '项目预算列表',
		component: budgetList,
		meta: {
			keepAlive: true // 需要缓存
		}
	},
	{
		path: '/app/project/pm/budgetDetail',
		name: '项目预算详情',
		component: budgetDetail,
		hidden: true
	},
	{
		path: '/project/projBudget/budgetApproval',
		name: '项目预算审批',
		component: budgetApproval
	}, // 与pc端路径保持一致
	{
		path: '/app/workRep/fbApply',
		name: '差旅管理',
		component: flybackApply,
		meta: {
			keepAlive: true // 需要缓存
		}
	},
	{
		path: '/app/workRep/fbApplyDetail',
		name: '差旅明细',
		component: flybackApplyDetail,
		hidden: true
	},
	{
		path: '/app/workRep/fbApproval',
		name: '差旅审批',
		component: flybackApproval
	},
	{
		path: '/app/workRep/fbApplyList',
		name: '差旅查询',
		component: flybackApplyList,
		meta: {
			keepAlive: true // 需要缓存
		}
	},
	{
		path: '/app/workRep/flybackApplyView',
		name: '差旅详细',
		component: flybackApplyView,
		hidden: true
	},
	{
		path: '/app/remb/costList',
		name: 'costList',
		component: costList,
		meta: {
			keepAlive: true // 需要缓存
		}
	},
	{
		path: '/costDetail',
		name: 'costDetail',
		component: costDetail
	},
	{
		path: '/demo',
		name: 'demo',
		component: demo
	},
	{
		path: '/demo2',
		name: 'demo2',
		component: demo2
	},
	{
		path: '/editMenu',
		name: 'editMenu',
		component: editMenu
	},
	{
		path: '/app/project/contract/contractOverview',
		name: '合同总览',
		component: contractOverview
	},
	{
		path: '/app/project/contract/contractList',
		name: '合同列表',
		component: contractList,
		meta: {
			keepAlive: true // 需要缓存
		}
	},
	{
		path: '/pwd/modify',
		name: '修改密码',
		component: modifyPwd,
		hidden: true
	},

	{
		path: '/contract/technicalSoftwareDetail',
		name: '技术/软件详情',
		component: technicalSoftwareDetail,
		hidden: true
	},
	{
		path: '/contract/humanDayServiceDetail',
		name: '人天服务详情',
		component: humanDayServiceDetail,
		hidden: true
	},
	{
		path: '/contract/humanDayTotalDetail',
		name: '人天服务总价详情',
		component: humanDayTotalDetail,
		hidden: true
	},
	{
		path: '/contract/purchaseDetail',
		name: '采购合同详情',
		component: purchaseDetail,
		hidden: true
	},
	{
		path: '/contract/ctripDetail',
		name: '携程商旅详情',
		component: ctripDetail,
		hidden: true
	},
	{
		path: '/contract/humanDayoutDetail',
		name: '人天外包详情',
		component: humanDayoutDetail,
		hidden: true
	},
	{
		path: '/contract/otherPaymentContractDetail',
		name: '其他付款合同详情',
		component: humanDayoutDetail,
		hidden: true
	},
	{
		path: '/contract/approveCont',
		name: '合同审批',
		component: approveCont,
		hidden: true
	},
	{
		path: '/app/project/payRecord/payRecordList',
		name: '付款列表',
		component: payRecordList, meta: { keepAlive: true }
	},
	{
		path: '/payRecord/payPurchaseDetail',
		name: '付款记录-采购合同',
		component: payPurchaseDetail,
		hidden: true
	},
	{
		path: '/payRecord/payCtripDetail',
		name: '付款记录-携程',
		component: payCtripDetail,
		hidden: true
	},
	{
		path: '/payRecord/payHumanDayDetail',
		name: '付款记录-人天服务',
		component: payHumanDayDetail,
		hidden: true
	},
	{
		path: '/payRecord/ctripPersonInfo',
		name: '携程-人员详情',
		component: ctripPersonInfo,
		hidden: true
	},
	{
		path: '/payRecord/approvePay',
		name: '付款合同审批',
		component: approvePay
	},
	/** ************** 企业微信相关***************** */
	{
		path: '/wechat/taskLoading',
		name: '任务加载页面',
		component: taskLoading
	},
	{
		path: '/wechat/taskCenterLoading',
		name: '任务中心加载页面',
		component: taskCenterLoading
	},
	{
		path: '/wechat/taskCenter',
		name: '任务中心加载页面',
		component: taskCenter, meta: { keepAlive: true }
	},
	{
		path: '/wechat/dailyDeal',
		name: '日报处理页面',
		component: dailyDeal
	},
	{
		path: '/workReport/wr/weekReportDetail',
		name: '周报详细页面',
		component: weekReportDetail
	},
	{
		path: '/test/preview',
		name: '预览测试',
		component: preview
	},
	{ path: '/app/workRep/flowApply', name: '流程管理', component: flowApplyList, meta: { keepAlive: true } },
	{ path: '/app/workRep/flowApplyDetail', name: '流程详细', component: flowApplyDetail, hidden: true },
	{ path: '/app/workRep/flowApplyEdit', name: '流程编辑', component: flowApplyEdit, hidden: true },
	{ path: '/app/workRep/flowApplyAudit', name: '流程审批', component: flowApplyAudit, hidden: true },
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js